import React from 'react';
import {
  IEvents,
  IMapLessonItemStates,
  IMapTemplates,
  ISubjects,
  MapTemplate,
  MapType,
  StaticRoomsProps,
} from 'types';
import { EventTypes } from 'utils/constants/eventTypes';
import mapLessonItemHOC from 'components/common/maps/MapLessonItemHOC';

// Map items little pigs
import LittlePigsMath from 'components/common/maps/little-pigs/lessons/math';
import LittlePigsLibrary from 'components/common/maps/little-pigs/lessons/library';
import LittlePigsMultiPurpose from 'components/common/maps/little-pigs/lessons/multi-purpose';
import LittlePigsGym from 'components/common/maps/little-pigs/lessons/gym';
import LittlePigsMakersPlace from 'components/common/maps/little-pigs/lessons/makersplace';
import LittlePigsPlayGround from 'components/common/maps/little-pigs/lessons/playground';
import LittlePigsLanguageArt from 'components/common/maps/little-pigs/lessons/language-art';
import LittlePigsCafeteria from 'components/common/maps/little-pigs/lessons/cafeteria';
import LittlePigsScience from 'components/common/maps/little-pigs/lessons/science';
import LittlePigsArt from 'components/common/maps/little-pigs/lessons/art';
import LittlePigsSocial from 'components/common/maps/little-pigs/lessons/social';
import LittlePigsMusic from 'components/common/maps/little-pigs/lessons/music';

import LittlePigsTrope1 from 'components/common/maps/little-pigs/background-trope/trope-decor-1';
import LittlePigsTrope2 from 'components/common/maps/little-pigs/background-trope/trope-decor-2';
import LittlePigsTrope3 from 'components/common/maps/little-pigs/background-trope/trope-decor-3';
import LittlePigsTrope4 from 'components/common/maps/little-pigs/background-trope/trope-decor-4';
import LittlePigsTrope5 from 'components/common/maps/little-pigs/background-trope/trope-decor-5';
import LittlePigsTrope6 from 'components/common/maps/little-pigs/background-trope/trope-decor-6';
import LittlePigsDecor1 from 'components/common/maps/little-pigs/background-map/map-decor-1';
import LittlePigsDecor2 from 'components/common/maps/little-pigs/background-map/map-decor-2';
import LittlePigsDecor3 from 'components/common/maps/little-pigs/background-map/map-decor-3';
import LittlePigsDecor4 from 'components/common/maps/little-pigs/background-map/map-decor-4';

import LittlePigsStaticElements from 'components/common/maps/little-pigs/static/staticElements';

import LittlePigsStaticRooms from 'components/common/maps/little-pigs/static/staticRooms';

// Map items fantasy land
import FantasyLandMath from 'components/common/maps/fantasy-land/lessons/math';
import FantasyLandLibrary from 'components/common/maps/fantasy-land/lessons/library';
import FantasyLandMultiPurpose from 'components/common/maps/fantasy-land/lessons/multi-purpose';
import FantasyLandGym from 'components/common/maps/fantasy-land/lessons/gym';
import FantasyLandMakersPlace from 'components/common/maps/fantasy-land/lessons/makersplace';
import FantasyLandPlayGround from 'components/common/maps/fantasy-land/lessons/playground';
import FantasyLandLanguageArt from 'components/common/maps/fantasy-land/lessons/language-art';
import FantasyLandCafeteria from 'components/common/maps/fantasy-land/lessons/cafeteria';
import FantasyLandScience from 'components/common/maps/fantasy-land/lessons/science';
import FantasyLandSocial from 'components/common/maps/fantasy-land/lessons/social';
import FantasyLandMusic from 'components/common/maps/fantasy-land/lessons/music';
import FantasyLandArt from 'components/common/maps/fantasy-land/lessons/art';

import FantasyLandTrope1 from 'components/common/maps/fantasy-land/background-trope/trope-decor-1';
import FantasyLandDecor2 from 'components/common/maps/fantasy-land/background-map/map-decor-2';
import FantasyLandTrope2 from 'components/common/maps/fantasy-land/background-trope/trope-decor-2';
import FantasyLandDecor1 from 'components/common/maps/fantasy-land/background-map/map-decor-1';
import FantasyLandDecor3 from 'components/common/maps/fantasy-land/background-map/map-decor-3';
import FantasyLandTrope3 from 'components/common/maps/fantasy-land/background-trope/trope-decor-3';
import FantasyLandTrope4 from 'components/common/maps/fantasy-land/background-trope/trope-decor-4';
import FantasyLandTrope5 from 'components/common/maps/fantasy-land/background-trope/trope-decor-5';
import FantasyLandTrope6 from 'components/common/maps/fantasy-land/background-trope/trope-decor-6';
import FantasyLandDecor4 from 'components/common/maps/fantasy-land/background-map/map-decor-4';

import FantasyLandStaticElements from 'components/common/maps/fantasy-land/static/staticElements';

import FantasyLandStaticRooms from 'components/common/maps/fantasy-land/static/staticRooms';

// Map items undersea
import UnderseaMath from 'components/common/maps/undersea/lessons/math';
import UnderseaLibrary from 'components/common/maps/undersea/lessons/library';
import UnderseaMultiPurpose from 'components/common/maps/undersea/lessons/multi-purpose';
import UnderseaGym from 'components/common/maps/undersea/lessons/gym';
import UnderseaMakersPlace from 'components/common/maps/undersea/lessons/makersplace';
import UnderseaPlayGround from 'components/common/maps/undersea/lessons/playground';
import UnderseaLanguageArt from 'components/common/maps/undersea/lessons/language-art';
import UnderseaCafeteria from 'components/common/maps/undersea/lessons/cafeteria';
import UnderseaScience from 'components/common/maps/undersea/lessons/science';
import UnderseaSocial from 'components/common/maps/undersea/lessons/social';
import UnderseaMusic from 'components/common/maps/undersea/lessons/music';
import UnderseaArt from 'components/common/maps/undersea/lessons/art';

import UnderseaTrope1 from 'components/common/maps/undersea/background-trope/trope-decor-1';
import UnderseaDecor2 from 'components/common/maps/undersea/background-map/map-decor-2';
import UnderseaTrope2 from 'components/common/maps/undersea/background-trope/trope-decor-2';
import UnderseaDecor1 from 'components/common/maps/undersea/background-map/map-decor-1';
import UnderseaDecor3 from 'components/common/maps/undersea/background-map/map-decor-3';
import UnderseaTrope3 from 'components/common/maps/undersea/background-trope/trope-decor-3';
import UnderseaTrope4 from 'components/common/maps/undersea/background-trope/trope-decor-4';
import UnderseaTrope5 from 'components/common/maps/undersea/background-trope/trope-decor-5';
import UnderseaTrope6 from 'components/common/maps/undersea/background-trope/trope-decor-6';
import UnderseaDecor4 from 'components/common/maps/undersea/background-map/map-decor-4';

import UnderseaStaticElements from 'components/common/maps/undersea/static/staticElements';

import UnderseaStaticRooms from 'components/common/maps/undersea/static/staticRooms';

// Map items future city
import FutureCityMath from 'components/common/maps/future-city/lessons/math';
import FutureCityLibrary from 'components/common/maps/future-city/lessons/library';
import FutureCityMultiPurpose from 'components/common/maps/future-city/lessons/multi-purpose';
import FutureCityGym from 'components/common/maps/future-city/lessons/gym';
import FutureCityMakersPlace from 'components/common/maps/future-city/lessons/makersplace';
import FutureCityPlayGround from 'components/common/maps/future-city/lessons/playground';
import FutureCityLanguageArt from 'components/common/maps/future-city/lessons/language-art';
import FutureCityCafeteria from 'components/common/maps/future-city/lessons/cafeteria';
import FutureCityScience from 'components/common/maps/future-city/lessons/science';
import FutureCitySocial from 'components/common/maps/future-city/lessons/social';
import FutureCityMusic from 'components/common/maps/future-city/lessons/music';
import FutureCityArt from 'components/common/maps/future-city/lessons/art';

import FutureCityTrope1 from 'components/common/maps/future-city/background-trope/trope-decor-1';
import FutureCityDecor2 from 'components/common/maps/future-city/background-map/map-decor-2';
import FutureCityTrope2 from 'components/common/maps/future-city/background-trope/trope-decor-2';
import FutureCityDecor1 from 'components/common/maps/future-city/background-map/map-decor-1';
import FutureCityDecor3 from 'components/common/maps/future-city/background-map/map-decor-3';
import FutureCityTrope3 from 'components/common/maps/future-city/background-trope/trope-decor-3';
import FutureCityTrope4 from 'components/common/maps/future-city/background-trope/trope-decor-4';
import FutureCityTrope5 from 'components/common/maps/future-city/background-trope/trope-decor-5';
import FutureCityTrope6 from 'components/common/maps/future-city/background-trope/trope-decor-6';
import FutureCityDecor4 from 'components/common/maps/future-city/background-map/map-decor-4';

import FutureCityStaticElements from 'components/common/maps/future-city/static/staticElements';

import FutureCityStaticRooms from 'components/common/maps/future-city/static/staticRooms';

import { SVG_VIEWBOX_WIDTH } from 'utils/constants/map';

export const mapStaticElements: IMapTemplates<React.FC> = {
  littlePigs: LittlePigsStaticElements,
  fantasyLand: FantasyLandStaticElements,
  undersea: UnderseaStaticElements,
  futureCity: FutureCityStaticElements,
  design5: FantasyLandStaticElements,
  design6: FantasyLandStaticElements,
  design7: FantasyLandStaticElements,
  design8: FantasyLandStaticElements,
};

export const mapStaticRooms: IMapTemplates<React.FC<StaticRoomsProps>> = {
  littlePigs: LittlePigsStaticRooms,
  fantasyLand: FantasyLandStaticRooms,
  undersea: UnderseaStaticRooms,
  futureCity: FutureCityStaticRooms,
  design5: FantasyLandStaticRooms,
  design6: FantasyLandStaticRooms,
  design7: FantasyLandStaticRooms,
  design8: FantasyLandStaticRooms,
};

const littlePigsSubjects: ISubjects = {
  art: LittlePigsArt,
  cafeteria: LittlePigsCafeteria,
  gym: LittlePigsGym,
  languageArt: LittlePigsLanguageArt,
  library: LittlePigsLibrary,
  makersPlace: LittlePigsMakersPlace,
  multiPurpose: LittlePigsMultiPurpose,
  music: LittlePigsMusic,
  math: LittlePigsMath,
  playGround: LittlePigsPlayGround,
  science: LittlePigsScience,
  social: LittlePigsSocial,
};

const fantasyLandSubjects: ISubjects = {
  art: FantasyLandArt,
  cafeteria: FantasyLandCafeteria,
  gym: FantasyLandGym,
  languageArt: FantasyLandLanguageArt,
  library: FantasyLandLibrary,
  makersPlace: FantasyLandMakersPlace,
  multiPurpose: FantasyLandMultiPurpose,
  music: FantasyLandMusic,
  math: FantasyLandMath,
  playGround: FantasyLandPlayGround,
  science: FantasyLandScience,
  social: FantasyLandSocial,
};

const underseaSubjects: ISubjects = {
  art: UnderseaArt,
  cafeteria: UnderseaCafeteria,
  gym: UnderseaGym,
  languageArt: UnderseaLanguageArt,
  library: UnderseaLibrary,
  makersPlace: UnderseaMakersPlace,
  multiPurpose: UnderseaMultiPurpose,
  music: UnderseaMusic,
  math: UnderseaMath,
  playGround: UnderseaPlayGround,
  science: UnderseaScience,
  social: UnderseaSocial,
};

const futureCitySubjects: ISubjects = {
  art: FutureCityArt,
  cafeteria: FutureCityCafeteria,
  gym: FutureCityGym,
  languageArt: FutureCityLanguageArt,
  library: FutureCityLibrary,
  makersPlace: FutureCityMakersPlace,
  multiPurpose: FutureCityMultiPurpose,
  music: FutureCityMusic,
  math: FutureCityMath,
  playGround: FutureCityPlayGround,
  science: FutureCityScience,
  social: FutureCitySocial,
};

const subjects: IMapTemplates<ISubjects> = {
  littlePigs: littlePigsSubjects,
  fantasyLand: fantasyLandSubjects,
  undersea: underseaSubjects,
  futureCity: futureCitySubjects,
  design5: fantasyLandSubjects,
  design6: fantasyLandSubjects,
  design7: fantasyLandSubjects,
  design8: fantasyLandSubjects,
};

function getMapComponentByType(subject: EventTypes, mapTemplate: MapTemplate) {
  switch (subject) {
    case EventTypes.art:
      return subjects[mapTemplate].art;
    case EventTypes.cafeteria:
      return subjects[mapTemplate].cafeteria;
    case EventTypes.gym:
      return subjects[mapTemplate].gym;
    case EventTypes.languageArts:
      return subjects[mapTemplate].languageArt;
    case EventTypes.library:
      return subjects[mapTemplate].library;
    case EventTypes.makersplace:
      return subjects[mapTemplate].makersPlace;
    case EventTypes.math:
      return subjects[mapTemplate].math;
    case EventTypes.multipurpose:
      return subjects[mapTemplate].multiPurpose;
    case EventTypes.playground:
      return subjects[mapTemplate].playGround;
    case EventTypes.science:
      return subjects[mapTemplate].science;
    case EventTypes.socialStudies:
      return subjects[mapTemplate].social;
    case EventTypes.music:
      return subjects[mapTemplate].music;
    default:
      return null;
  }
}

export function isActiveLesson(l: IEvents): boolean {
  const startMS = new Date(l.startTime).getTime();
  const endMS = new Date(l.endTime).getTime();
  const nowMS = new Date().getTime();

  return nowMS >= startMS && nowMS < endMS;
}

export function getActiveLesson(lessons: IEvents[]): IEvents | undefined {
  return lessons.find(isActiveLesson);
}

type LessonEntry = { lessons: IEvents[]; El: React.FC<IMapLessonItemStates> };
export const getLessons = (
  lessons: IEvents[],
  mapType: MapType,
  mapTemplate: MapTemplate,
  unitId: number | undefined
): JSX.Element[] => {
  const mapEntries: LessonEntry[] = [];

  const mapIsStatic = mapType === MapType.Static;

  lessons.forEach((l: IEvents) => {
    const El = getMapComponentByType(l.subject, mapTemplate);
    if (!El) {
      return;
    }

    if (mapIsStatic) {
      const entryIndex = mapEntries.findIndex((el) => el.El === El);
      const alreadyExist = entryIndex >= 0;

      if (alreadyExist) {
        mapEntries[entryIndex].lessons.push(l);
        return;
      }
    }

    mapEntries.push({
      lessons: [l],
      El,
    });
  });

  return mapEntries.map((entry, i) => {
    const RenderElement = mapLessonItemHOC(
      entry.El,
      entry.lessons,
      mapType,
      unitId
    );

    const staticSubjectClassName = entry.lessons[0].subject.replace(' ', '-');
    const linearSubjectClassName = `map-element-${i + 1}`;

    return (
      <g
        key={i.toString()}
        className={`prefix__item-map ${
          mapIsStatic ? staticSubjectClassName : linearSubjectClassName
        }`}
      >
        {RenderElement}
      </g>
    );
  });
};

interface IMapDecorations {
  decor1: React.FC;
  decor2: React.FC;
  decor3: React.FC;
  decor4: React.FC;
  trope1: React.FC;
  trope2: React.FC;
  trope3: React.FC;
  trope4: React.FC;
  trope5: React.FC;
  trope6: React.FC;
}

const littlePigsDecorations: IMapDecorations = {
  decor1: LittlePigsDecor1,
  decor2: LittlePigsDecor2,
  decor3: LittlePigsDecor3,
  decor4: LittlePigsDecor4,
  trope1: LittlePigsTrope1,
  trope2: LittlePigsTrope2,
  trope3: LittlePigsTrope3,
  trope4: LittlePigsTrope4,
  trope5: LittlePigsTrope5,
  trope6: LittlePigsTrope6,
};

const fantasyLandDecorations: IMapDecorations = {
  decor1: FantasyLandDecor1,
  decor2: FantasyLandDecor2,
  decor3: FantasyLandDecor3,
  decor4: FantasyLandDecor4,
  trope1: FantasyLandTrope1,
  trope2: FantasyLandTrope2,
  trope3: FantasyLandTrope3,
  trope4: FantasyLandTrope4,
  trope5: FantasyLandTrope5,
  trope6: FantasyLandTrope6,
};

const underseaDecorations: IMapDecorations = {
  decor1: UnderseaDecor1,
  decor2: UnderseaDecor2,
  decor3: UnderseaDecor3,
  decor4: UnderseaDecor4,
  trope1: UnderseaTrope1,
  trope2: UnderseaTrope2,
  trope3: UnderseaTrope3,
  trope4: UnderseaTrope4,
  trope5: UnderseaTrope5,
  trope6: UnderseaTrope6,
};

const futureCityDecorations: IMapDecorations = {
  decor1: FutureCityDecor1,
  decor2: FutureCityDecor2,
  decor3: FutureCityDecor3,
  decor4: FutureCityDecor4,
  trope1: FutureCityTrope1,
  trope2: FutureCityTrope2,
  trope3: FutureCityTrope3,
  trope4: FutureCityTrope4,
  trope5: FutureCityTrope5,
  trope6: FutureCityTrope6,
};

const decorations: IMapTemplates<IMapDecorations> = {
  littlePigs: littlePigsDecorations,
  fantasyLand: fantasyLandDecorations,
  undersea: underseaDecorations,
  futureCity: futureCityDecorations,
  design5: fantasyLandDecorations,
  design6: fantasyLandDecorations,
  design7: fantasyLandDecorations,
  design8: fantasyLandDecorations,
};

export const getDecorations = (
  mapTemplate: MapTemplate,
  mapType: MapType,
  mapElementsCount: number
): JSX.Element | React.FC => {
  const mapIsStatic = mapType === MapType.Static;
  const d = decorations[mapTemplate];

  switch (mapElementsCount) {
    case 1:
      return mapIsStatic ? (
        <d.decor1 />
      ) : (
        <>
          <d.trope1 />
          <d.decor1 />
        </>
      );
    case 2:
      return mapIsStatic ? (
        <d.decor2 />
      ) : (
        <>
          <d.trope1 />
          <d.decor2 />
        </>
      );
    case 3:
    case 4:
    case 5:
      return mapIsStatic ? (
        <d.decor2 />
      ) : (
        <>
          <d.trope2 />
          <d.decor2 />
        </>
      );
    case 6:
    case 7:
    case 8:
      return mapIsStatic ? (
        <d.decor3 />
      ) : (
        <>
          <d.trope3 />
          <d.decor3 />
        </>
      );
    case 9:
    case 10:
    case 11:
      return mapIsStatic ? (
        <d.decor4 />
      ) : (
        <>
          <d.trope4 />
          <d.decor4 />
        </>
      );
    case 12:
      return mapIsStatic ? (
        <d.decor4 />
      ) : (
        <>
          <d.trope5 />
          <d.trope6 />
          <d.decor4 />
        </>
      );
    default:
      return <d.decor1 />;
  }
};

export const getLessonsClass = (lessonsCount: number): string => {
  switch (lessonsCount) {
    case 1:
      // TODO change it to something readable for devs like 'state-1', 'state-2'
      return 'one';
    case 2:
      return 'two';
    case 3:
      return 'three';
    case 4:
      return 'four';
    case 5:
      return 'five';
    case 6:
      return 'six';
    case 7:
      return 'seven';
    case 8:
      return 'eight';
    case 9:
      return 'nine';
    case 10:
      return 'ten';
    case 11:
      return 'eleven';
    case 12:
      return 'twelve';
    default:
      return 'lessons-wrap';
  }
};

export const getGreetingPosition = (textEl: SVGTextElement): number => {
  const textWidth = textEl ? textEl.getBoundingClientRect().width : 0;
  const pos = SVG_VIEWBOX_WIDTH / 2 - textWidth / 2;

  return pos;
};
